"use strict";

import {onEnterViewPort} from "@elements/viewport-utils";
import {initInScope,onFind} from "@elements/init-modules-in-scope";
import {findIn,closest,removeClass, findAllIn, findAll, on, off, removeAttribute, addClass, hasClass, setAttribute} from '@elements/dom-utils';
import {renderTemplate} from "./render-template";

const selectors = {
    base: '.js-nav',
    toggleOverlay: '.js-nav__toggle-overlay',
    showOverlay: '.js-nav__show-overlay',
    collapse: '.js-nav__collapse',
    overlay: '.js-nav__overlay',
    list: '.js-nav__list',
    listItem: '.js-nav__list-item',
    listToggle: '.js-nav__list-toggle'
};

const isMobile = () => matchMedia('(max-width: 767px)').matches;

export function init () {
    onFind(selectors.base, function (baseElement) {
        let toggleOverlays = findAll(selectors.toggleOverlay);
        let showOverlays = findAll(selectors.showOverlay);

        showOverlays.forEach(function(toggleOverlay) {
            on('click', function (evt) {
                let targetId = toggleOverlay.getAttribute('data-nav-overlay-target');
                let overlayItem = findIn(targetId, baseElement);
                let renderTemplateItem = findIn('.js-render-template', baseElement);

                if(renderTemplateItem) {
                    renderTemplate(renderTemplateItem);
                }

                addClass('show-overlay', overlayItem);
                setAttribute('aria-expanded', true, overlayItem);
                removeAttribute('aria-hidden', overlayItem);
                removeAttribute('inert', overlayItem);
                addClass('body--freezed', document.body);

            }, toggleOverlay);
        });

        toggleOverlays.forEach(function(toggleOverlay) {
            on('click', function(evt) {
                console.log("CLICKED");
                let targetId = toggleOverlay.getAttribute('data-nav-overlay-target');
                let overlayItem = findIn(targetId, baseElement);
                let renderTemplateItem = findIn('.js-render-template', baseElement);

                if(renderTemplateItem) {
                    renderTemplate(renderTemplateItem);
                }

                if(hasClass('show-overlay', overlayItem)) {
                    hideItem(toggleOverlay);
                    hideOverlay(overlayItem);
                    removeClass('body--freezed', document.body);
                } else {
                    showItem(toggleOverlay);
                    showOverlay(overlayItem);
                    addClass('body--freezed', document.body);
                }

                function bodyClickHandler(evt) {
                    if (!closest('.main-navbar', evt.target)) {
                        evt.preventDefault();
                        hideItem(toggleOverlay);
                        hideOverlay(overlayItem);
                        removeClass('body--freezed', document.body);
                    }
                }

                function focusoutHandler(evt) {
                    // Small delay to check if focus moved to another element within the overlay
                    setTimeout(() => {
                        const activeElement = document.activeElement;
                        const isOverlayOpen = hasClass('show-overlay', overlayItem);

                        // Check if focus is still within the overlay or its toggle button
                        if (isOverlayOpen &&
                            !overlayItem.contains(activeElement) &&
                            activeElement !== toggleOverlay &&
                            !toggleOverlay.contains(activeElement)) {

                            hideItem(toggleOverlay);
                            hideOverlay(overlayItem);
                            removeClass('body--freezed', document.body);
                        }
                    }, 10);
                }

                function keydownHandler(evt) {
                    // Close overlay on Escape key
                    if (evt.key === 'Escape' && hasClass('show-overlay', overlayItem)) {
                        evt.preventDefault();
                        hideItem(toggleOverlay);
                        hideOverlay(overlayItem);
                        removeClass('body--freezed', document.body);
                        // Return focus to the toggle button
                        toggleOverlay.focus();
                    }
                }

                function showOverlay(overlay) {
                    addClass('show-overlay', overlay);
                    setAttribute('aria-expanded', true, overlay);
                    removeAttribute('aria-hidden', overlay);
                    removeAttribute('inert', overlay);
                    overlay.removeAttribute('inert');

                    // Add focus management event listeners
                    on('focusout', focusoutHandler, overlay);
                    on('keydown', keydownHandler, document);

                    if (!isMobile()) {
                        setTimeout(function() {
                            addBodyClickHandler(bodyClickHandler);
                        }, 300);
                    }
                }

                function hideOverlay(overlay) {
                    removeClass('show-overlay', overlay);
                    setAttribute('aria-expanded', false, overlay);
                    setAttribute('aria-hidden', 'true', overlay);
                    setAttribute('inert', '', overlay);

                    // Remove focus management event listeners
                    off('focusout', focusoutHandler, overlay);
                    off('keydown', keydownHandler, document);

                    if (!isMobile()) {
                        removeBodyClickHandler(bodyClickHandler);
                    }
                }

            }, toggleOverlay);
        });

        onFind(selectors.list, function (list) {
            let listItems = findAllIn(selectors.listItem, list);
            let listToggle = findAllIn(selectors.listToggle, list);

            listToggle.forEach(function(item) {
                on('click', function (evt) {
                    let element = evt.target;
                    evt.preventDefault();

                    let parentItem = closest(selectors.listItem, element);

                    if (hasClass('is-open', parentItem)) {
                        if (isMobile()) {
                            hideItem(parentItem);
                        } else {
                            hideItem(parentItem);
                        }
                    } else {
                        if (isMobile()) {
                            showItem(parentItem);
                        } else {
                            hideItems(listItems);
                            showItem(parentItem);
                        }
                    }
                }, item);
            });
        });
    });
}

function addBodyClickHandler(bodyClickHandler) {
    on('click', bodyClickHandler, document.body);
}
function removeBodyClickHandler(bodyClickHandler) {
    off('click', bodyClickHandler, document.body);
}
function hideItem(item) {
    removeClass('is-open', item);
    removeClass('is-open--only-desktop', item);
    setAttribute('aria-expanded', false, item);
}
function hideItems(items) {
    items.forEach(function(item) {
        removeClass('is-open', item);
        removeClass('is-open--only-desktop', item);
        setAttribute('aria-expanded', false, item);
    });

}
function showItem(item) {
    addClass('is-open', item);
    setAttribute('aria-expanded', true, item);
}
